import React, { useCallback } from 'react';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import {
	MENU_ID_PLANS,
	MENU_ID_PLANS_VIEW_ALL,
} from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { ViewAllEntityMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/view-all-entity-menu-item/index.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';
import { plansDirectoryRoute } from '@jira/router-routes__directories-routes/src/plansDirectoryRoute.tsx';

const viewAllPlans = defineMessage({
	id: 'navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'View all plans',
	description: 'Message for the view all plans menu item in the plans submenu',
});

const VIEW_ALL_PLANS_HREF = plansDirectoryRoute.path;

export const Nav4PlansFooter = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const viewAllPlansClickHandler = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), {
			action: 'clicked',
			actionSubject: 'navigationItem',
			actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_PLANS],
			attributes: {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM,
				itemId: 'viewAllPlans',
			},
		});
	}, [createAnalyticsEvent]);

	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<ViewAllEntityMenuItem
						href={VIEW_ALL_PLANS_HREF}
						menuId={MENU_ID_PLANS_VIEW_ALL}
						onClick={viewAllPlansClickHandler}
					>
						{formatMessage(viewAllPlans)}
					</ViewAllEntityMenuItem>
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
};
